import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";

export const GET_CMS = "GET_CMS";
export const SET_CMS_DATA = "SET_CMS_DATA";
export const CREATE_CMS = "CREATE_CMS";
export const RESET_CMS_DATA = "RESET_CMS_DATA";

export const UPDATE_CMS = "UPDATE_CMS";

export interface GetCmsAction {
  type: typeof GET_CMS;
  payload: { cms: CmsMasterData[]; count: number };
}

export interface SetCmsDetailAction {
  type: typeof SET_CMS_DATA;
  payload: CmsMasterData;
}
export interface createCms{
  type: typeof CREATE_CMS;
    payload: any; 
}
export interface updateCms{
  type: typeof UPDATE_CMS;
    payload: any; 
}
export interface ResetCms{
  type: typeof RESET_CMS_DATA;
}

export type CmsMasterActionTypes =
  | GetCmsAction
  | SetCmsDetailAction
  | createCms
  |updateCms
  |ResetCms
